//NPM LIBRARIES
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
//REDUX ACTIONS AND SELECTORS
import {getFormDataSelector} from '../../../FormStore/Selectors/FormDataSelectors';
import {addDeclaration} from '../../../FormStore/Actions/FormDataActions/MPL/AddMPLFormData';
import { addFormComplete } from '../../../FormStore/Actions/FormPropertyAction/FormPropertyAction';
//COMPONENTS AND UTILITIES
import StepNavigation from '../../../components/CASAForm/StepNavigation';
import { RepeatingSummary, MplExclusionRepeatingSummary } from '../../../components/CASAForm/CustomComponents/RepeatingSummary';
import {AUformGroup} from '@gov.au/form';
import {MPLSummaryHeaderVariations} from '../MPL/MPLStudentDetailsVariations/MPLStudentDetailsVariations';
import Question from '../../../components/CASAForm/Question';
import {addPageAlert, clearPageAlert} from "../../../PortalStore/Actions/PageAlertActions";
import CustomBackLink from "../../../components/CASAForm/ReusableQuestions/CustomBackLink";

class MPLStudentSummary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            declaration: '',
            showError: false
        }
    }

    addAnotherStudent = (e) => {
        e.preventDefault();

        this.props.addAdditionalStudent({
            courseCode: this.props.formData.courseCode,
            courseDescription: this.props.formData.courseDescription,
            courseOutcome: this.props.formData.courseOutcome
        })
        this.props.dispatch(clearPageAlert());
    }

    submitOnClick = (e) => {
        e.preventDefault();
        let errorTitle = "",
            errorMessage = "";

        if(!this.state.declaration) {
            errorTitle ="There was a problem with the form";
            errorMessage = "Please check the form below and try again";
        } else if (!Object.keys(this.props.formData.students).length) {
            errorTitle = "No applicants added to application"
        }

        if (!errorTitle) {
            this.props.dispatch(addDeclaration(this.state.declaration));
            this.props.pageAlert && this.props.dispatch(clearPageAlert());
            this.props.dispatch(addFormComplete());
            this.setState({showError: false});
        } else {
            this.setState({showError: true});
            this.props.dispatch(addPageAlert({
                level: 'error',
                title: errorTitle,
                message: errorMessage
            }));
        }
    }

    returnDeclarationAccept = (declaration) => {
        if (declaration.answer?.checkboxValues) {
            this.setState({
                declaration: declaration.answer?.checkboxValues[0]
            })
        }
    }

    previousStep = (e) => {
        e.preventDefault();

        this.props.onPreviousClick()
    }

    render() {
        return (
            <div id={this.props.id}>
                <CustomBackLink
                    id="previousStep"
                    action={this.previousStep}
                    text="Back"
                    direction="left"/>

                <h3>Notification summary</h3>

                <AUformGroup>
                    {this.props.formData.removalType?.value === 'category' ? 
                    <MplExclusionRepeatingSummary
                        caption={this.props.formData.courseDescription}
                        name="studentFullName"
                        tableHeader={MPLSummaryHeaderVariations(this.props.formData.courseOutcome)}
                        tableBody={this.props.formData.students}
                        editUserCallback={this.props.editUserCallback}
                        removeUserCallback={this.props.removeUserCallback}/> : 

                    <RepeatingSummary
                        caption={this.props.formData.courseDescription}
                        name="studentFullName"
                        tableHeader={MPLSummaryHeaderVariations(this.props.formData.courseOutcome)}
                        tableBody={this.props.formData.students}
                        editUserCallback={this.props.editUserCallback}
                        removeUserCallback={this.props.removeUserCallback}/>
                    }
                </AUformGroup>

                <div className="form-controls au-form-group">
                    <StepNavigation
                        label='Add another student'
                        disabled={Object.keys(this.props.formData.students).length >= 12}
                        action={this.addAnotherStudent}/>
                </div>

                <Question
                    id="declaration"
                    key="declaration"
                    questionid="declaration"
                    type="declaration"
                    name="declaration"
                    showError={this.state.showError}
                    label="I agree and understand the above conditions."
                    value="declaration"
                    stepid="summary"
                    returnQuestionData={this.returnDeclarationAccept}>
                    <p>I hereby certify that the training outcomes above are true and correct in every 
                        particular and that I am authorised to notify these results on behalf of the organisation. 
                        I acknowledge that to knowingly make a false statement in this notification is an offence 
                        against the Criminal Code Act 1995</p>
                </Question>

                <div className="form-controls au-form-group">
                    <StepNavigation
                        type="submit"
                        label='Submit'
                        action={this.submitOnClick}/>
                </div>
            </div>
        )
    }
}

MPLStudentSummary.propTypes = {
    id: PropTypes.string,
    formData: PropTypes.object,
    editUserCallback: PropTypes.func,
    removeUserCallback: PropTypes.func,
    dispatch: PropTypes.func,
    onPreviousClick: PropTypes.func,
    addAdditionalStudent: PropTypes.func,
    submitForm: PropTypes.func,
    pageAlert: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        formData: getFormDataSelector(state.formStore, 'mplFormData'),
        pageAlert: state.pageAlert
    }
}

export default connect(mapStateToProps)(MPLStudentSummary);